import { useEffect } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useMainContext } from '@contexts/Contexts';
import SingleTalk from '@components/SingleTalk/single-talk';

const ScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
		});
	}, [pathname]);

	return null;
};
export default function PageTalk() {
	const { dispatch } = useMainContext();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const talkId = searchParams.get('id');

	useEffect(() => {
		!talkId
			? navigate('/')
			: dispatch({ type: 'SET_SELECTED_TALK_ID', payload: talkId });
	}, [navigate, talkId]); // eslint-disable-line

	return (
		<>
			<ScrollToTop />
			<SingleTalk />
		</>
	);
}
